
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/ai-and-the-power-of-now-meta-2026",
      function () {
        return require("private-next-pages/events/ai-and-the-power-of-now-meta-2026.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/ai-and-the-power-of-now-meta-2026"])
      });
    }
  